import { render, staticRenderFns } from "./WebHostingWebsiteAdmins.vue?vue&type=template&id=2eba6edc&scoped=true&"
import script from "./WebHostingWebsiteAdmins.vue?vue&type=script&lang=js&"
export * from "./WebHostingWebsiteAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba6edc",
  null
  
)

export default component.exports